var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.75C4.4087 16.75 2.88258 16.1179 1.75736 14.9926C0.632141 13.8674 0 12.3413 0 10.75C0 6.75 6 0 6 0C6 0 12 6.75 12 10.75C12 12.3413 11.3679 13.8674 10.2426 14.9926C9.11742 16.1179 7.5913 16.75 6 16.75Z",
    fill: "#90AED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIcon);
export default __webpack_public_path__ + "static/media/water-icon.e8edd3f532dbdb193cfcbb0d7b97f358.svg";
export { ForwardRef as ReactComponent };